import { AVAILABLE_THEMES } from "./themes.consts";
import store from "../utils/store";
import { CATALOG, MENU } from "../consts/menuType.consts";

export const getTheme = (field) => {
    //change
    const url = window.location.host;
    let theme = AVAILABLE_THEMES["default"][field];
    Object.keys(AVAILABLE_THEMES).forEach(function (key) {
        if (url.includes(key)) {
            theme = AVAILABLE_THEMES[key][field];
        }
    });
    return theme;
};

export const isCatalog = () => {
    const currentStore = store.getState();
    return currentStore.menuType === CATALOG;
};

export const getVariableTheme = () => {
    const currentStore = store.getState();
    return currentStore.menuType === CATALOG ? "catalog" : "menus";
};
